import React, { useState } from 'react'
import ProjectsList from './ProjectsList'
import ProjectListSearch from './ProjectListSearch'

const ProjectsContainer = ({ projects_path, project_path, initalProjects }) => {
  const [projects, setProjects] = useState(initalProjects)

  const handleSearchResults = (newProjects) => {
    if (newProjects) {
      setProjects(newProjects)
    }
  }

  const handleProjectDelete = (project) => {
    setProjects(projects.filter((p) => p.id !== project.id))
  }

  return (
    <div className="flex flex-col gap-4">
      <ProjectListSearch
        projects_path={projects_path}
        onSearchResults={handleSearchResults}
      />
      <ProjectsList
        projects_path={projects_path}
        project_path={project_path}
        projects={projects}
        onProjectDelete={handleProjectDelete}
        onSearchResults={handleSearchResults}
      />
    </div>
  )
}

export default ProjectsContainer